export default {
  // Login form
  login: 'Iniciar Sesión',
  email: 'Email',
  password: 'Contraseña',
  showPassword: 'Mostrar contraseña',
  hidePassword: 'Ocultar contraseña',
  forgotPassword: '¿Olvidó su contraseña?',
  enter: 'Entrar',
  or: 'o',

  // SSO
  signInWithMicrosoft: 'Iniciar sesión con Microsoft',
  signInWithGoogle: 'Iniciar sesión con Google',
  continueWithMicrosoft: 'Continuar',

  // Recover password modal
  enterEmailToFindAccount: 'Ingresa tu correo electrónico para buscar tu cuenta.',
  send: 'Enviar',
  checkYourEmail: 'Revise su correo electrónico.',

  // SSO Institution modal
  microsoftSignIn: 'Inicio de sesión',
  institutionDetectedAutomatically: 'Institución detectada automáticamente',
  selectInstitution: 'Seleccione una institución',
  pleaseSelectInstitution: 'Por favor seleccione una institución',

  // SSO loading/errors
  redirectingToMicrosoft: 'Redirigiendo a Microsoft...',
  pleaseWait: 'Por favor espere',
  errorSigningIn: 'Error al iniciar sesión',
  errorSigningInWithMicrosoft: 'Ocurrió un error al iniciar sesión con Microsoft',
  errorDuringMicrosoftAuthentication: 'Ocurrió un error durante la autenticación con Microsoft',
  ssoErrorHint: 'Si crees que esto es un error, contacta al administrador de tu institución.',
  noSSOInstitutionsAvailable: 'No hay instituciones con SSO disponibles',
  useTraditionalSignIn: 'Por favor, use el inicio de sesión tradicional.',

  // SSO auto-login confirmation modal
  microsoftSSOAvailable: 'Inicio de sesión con Microsoft disponible',
  microsoftSSOConfirmText: 'La institución {institution} utiliza Microsoft para autenticación. ¿Deseas iniciar sesión con Microsoft?',
  microsoftSSOConfirm: 'Sí, usar Microsoft',
  microsoftSSODecline: 'No, usar credenciales',

  // Institution redirect (klearning.cl main domain)
  selectYourInstitution: 'Seleccione su institución',
}
